// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0960c08b","239":"0324bc35","455":"f959117f"}[chunkId] + ".chunk.js";
};